import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-service-section__inner" }
const _hoisted_3 = { class: "c-service-section__sections" }
const _hoisted_4 = { class: "c-service-section__group-header" }
const _hoisted_5 = { class: "c-service-section__group-body" }
const _hoisted_6 = { class: "c-service-section__venn" }
const _hoisted_7 = { class: "c-service-section__services" }
const _hoisted_8 = { class: "c-service-section__cards" }
const _hoisted_9 = { class: "c-service-section__card-line" }

import { computed } from 'vue';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-vue';
import type {
  ServiceSectionCardFields,
  ServiceSectionGroupFields,
  ServiceSectionProps,
  ServiceSectionVennItemFields,
} from '@/types/components/ServiceSection';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';

type ServiceSectionGroup = ScItem<ServiceSectionGroupFields> & {
  fields: ServiceSectionGroupFields;
};
type ServiceSectionVennItem = ScItem<ServiceSectionVennItemFields> & {
  fields: ServiceSectionVennItemFields;
};
type ServiceSectionCard = ScItem<ServiceSectionCardFields> & {
  fields: ServiceSectionCardFields;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceSection',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);
const rendering = computed(() => props.rendering);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-service-section'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const sections = computed<ServiceSectionGroup[]>(() => {
  const items = utils.sc.getFieldObj(fields.value, 'sections');
  return Array.isArray(items)
    ? items.filter((item): item is ServiceSectionGroup => Boolean(item?.fields))
    : [];
});

const getTheme = (index: number) => (index === 0 ? 'developability' : 'functionality');

const getPosition = (index: number) => ['left', 'right', 'bottom', 'center'][index] || 'center';

const getVennItems = (section: ServiceSectionGroup): ServiceSectionVennItem[] =>
  Array.isArray(section.fields.vennItems)
    ? section.fields.vennItems.filter((item): item is ServiceSectionVennItem =>
        Boolean(item?.fields)
      )
    : [];

const getServiceCards = (section: ServiceSectionGroup): ServiceSectionCard[] =>
  Array.isArray(section.fields.serviceCards)
    ? section.fields.serviceCards.filter((item): item is ServiceSectionCard =>
        Boolean(item?.fields)
      )
    : [];

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value && sections.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: rendering.value?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "tablet-default-grid": [1, 14],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section, sectionIndex) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: section.id || section.fields.title?.value,
                    class: _normalizeClass(["c-service-section__group", `c-service-section__group--${getTheme(sectionIndex)}`])
                  }, [
                    _createElementVNode("header", _hoisted_4, [
                      _createVNode(_component_JssRichText, {
                        field: section.fields?.title,
                        tag: "h2"
                      }, null, 8, ["field"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", {
                          class: "c-service-section__venn-circle c-service-section__venn-circle--left",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _cache[1] || (_cache[1] = _createElementVNode("span", {
                          class: "c-service-section__venn-circle c-service-section__venn-circle--right",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("span", {
                          class: "c-service-section__venn-circle c-service-section__venn-circle--bottom",
                          "aria-hidden": "true"
                        }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVennItems(section), (item, index) => {
                          return (_openBlock(), _createBlock(_unref(Text), {
                            key: item.id || item.fields.label?.value,
                            tag: "span",
                            class: _normalizeClass(["c-service-section__venn-label", `c-service-section__venn-label--${getPosition(index)}`]),
                            field: item.fields.label
                          }, null, 8, ["class", "field"]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        (section.fields.servicesTitle?.value)
                          ? (_openBlock(), _createBlock(_unref(Text), {
                              key: 0,
                              tag: "h3",
                              class: "c-service-section__services-title",
                              field: section.fields.servicesTitle
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServiceCards(section), (card) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: card.id || card.fields.title?.value,
                              class: "c-service-section__card"
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                (card.fields.title?.value)
                                  ? (_openBlock(), _createBlock(_unref(Text), {
                                      key: 0,
                                      tag: "strong",
                                      class: "c-service-section__card-title",
                                      field: card.fields.title
                                    }, null, 8, ["field"]))
                                  : _createCommentVNode("", true),
                                (card.fields.content?.value)
                                  ? (_openBlock(), _createBlock(_unref(RichText), {
                                      key: 1,
                                      tag: "div",
                                      class: "c-service-section__card-content",
                                      field: card.fields.content
                                    }, null, 8, ["field"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 2))
                }), 128))
              ]),
              (fields.value.bottomStatement?.value)
                ? (_openBlock(), _createBlock(_unref(RichText), {
                    key: 0,
                    class: "c-service-section__statement",
                    field: fields.value.bottomStatement
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})